module.exports = __webpack_public_path__ + "img/access-control.c0bcd0b8.svg";